import { render, staticRenderFns } from "./segment.vue?vue&type=template&id=fe896c34&"
import script from "./segment.vue?vue&type=script&lang=ts&"
export * from "./segment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports